/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GdsRcptTrackingReportTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const gdsRcptTrackingReportReportLoading = (state, { boolean }) => ({
  ...state,
  reportIsLoading: boolean
});

export const gdsRcptTrackingReportInitGdsRcptTrackingSuccess = (state, { criteria }) => ({
  ...state,
  criteria
});

export const gdsRcptTrackingReportGdsRcptTrackingSuccess = (state, { criteria, reportData }) => ({
  ...state,
  criteria,
  reportData
});

export const gdsRcptTrackingReportFetchDivisionOptionLoading = (state, { boolean }) => ({
  ...state,
  divisionIsLoading: boolean
});

export const gdsRcptTrackingReportFetchDivisionOptionSuccess = (state, { options }) => ({
  ...state,
  divisionOptions: options
});

export const gdsRcptTrackingReportFetchBizPartnerOptionLoading = (state, { boolean }) => ({
  ...state,
  bizPartnerIsLoading: boolean
});

export const gdsRcptTrackingReportFetchBizPartnerOptionSuccess = (state, { options }) => ({
  ...state,
  bizPartnerOptions: options
});

export const gdsRcptTrackingReportFetchDebtorOptionLoading = (state, { boolean }) => ({
  ...state,
  debtorIsLoading: boolean
});

export const gdsRcptTrackingReportFetchDebtorOptionSuccess = (state, { options }) => ({
  ...state,
  debtorOptions: options
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_REPORT_LOADING]: gdsRcptTrackingReportReportLoading,
  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_INIT_GDS_RCPT_TRACKING_SUCCESS]: gdsRcptTrackingReportInitGdsRcptTrackingSuccess,
  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_GDS_RCPT_TRACKING_SUCCESS]: gdsRcptTrackingReportGdsRcptTrackingSuccess,

  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_DIVISION_OPTION_LOADING]: gdsRcptTrackingReportFetchDivisionOptionLoading,
  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_DIVISION_OPTION_SUCCESS]: gdsRcptTrackingReportFetchDivisionOptionSuccess,

  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_BIZ_PARTNER_OPTION_LOADING]: gdsRcptTrackingReportFetchBizPartnerOptionLoading,
  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_BIZ_PARTNER_OPTION_SUCCESS]: gdsRcptTrackingReportFetchBizPartnerOptionSuccess,

  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_DEBTOR_OPTION_LOADING]: gdsRcptTrackingReportFetchDebtorOptionLoading,
  [GdsRcptTrackingReportTypes.GDS_RCPT_TRACKING_REPORT_FETCH_DEBTOR_OPTION_SUCCESS]: gdsRcptTrackingReportFetchDebtorOptionSuccess
});
